import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SpaceReadModel, useDeleteSpacesByIdMutation } from '@client/api';
import { Button, Modal, ModalFooter } from '@client/toolkit';
import { DeleteConfirmationModalContent } from '../../../../../components/delete-confirmation-modal-content/delete-confirmation-modal-content';

interface SpaceDeleteModalProps {
  space: SpaceReadModel;
  open: boolean;
  onDeleteFulfilled: () => void;
  onCancel: () => void;
}

export const SpaceDeleteModal = ({ space, open, onCancel, onDeleteFulfilled }: SpaceDeleteModalProps) => {
  const { t: tCommon } = useTranslation();

  const [mutation, { isLoading: isDeleting }] = useDeleteSpacesByIdMutation();

  const handleDelete = useCallback(async () => {
    if (space?.id == null) return;
    try {
      await mutation({ id: space.id }).unwrap();
    } catch {
      return;
    }
    onDeleteFulfilled();
  }, [mutation, onDeleteFulfilled, space.id]);

  const handleClose = () => {
    onCancel();
  };

  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose} closeDisabled={isDeleting}>
      <DeleteConfirmationModalContent name={space?.name ?? ''} />
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleDelete} progressing={isDeleting}>
          {tCommon('delete')}
        </Button>
        <Button color="primary-dark" onClick={handleClose}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
